webpackJsonp([269829036549620],{

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  ', ';\n'], ['\n  ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  ', ';\n\n  ', ' {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    @media (min-width: ', ') {\n      grid-column: 1 / 8;\n    }\n  }\n\n  @media (min-width: ', ') {\n    .gatsby-image-outer-wrapper {\n      grid-column: 8 / -1;\n    }\n  }\n'], ['\n  ', ';\n\n  ', ' {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    @media (min-width: ', ') {\n      grid-column: 1 / 8;\n    }\n  }\n\n  @media (min-width: ', ') {\n    .gatsby-image-outer-wrapper {\n      grid-column: 8 / -1;\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  ', ';\n  background-color: ', ';\n  padding: 1rem ', ';\n\n  ', ' {\n    background-color: ', ';\n    color: #fff;\n    padding: 1rem;\n    @media (min-width: ', ') {\n      grid-column: 1 / 9;\n      grid-row: 1 / 2;\n    }\n  }\n\n  ', ' {\n    height: 100%;\n  }\n\n  ', ' {\n    ul {\n      display: flex;\n      flex-wrap: wrap;\n    }\n\n    li {\n      &:not(:last-child)::after {\n        content: \'\xB7\';\n        font-weight: bold;\n        margin-left: 0.5rem;\n        margin-right: 0.5rem;\n      }\n    }\n  }\n\n  @media (min-width: ', ') {\n    .gatsby-image-outer-wrapper {\n      &:nth-child(2) {\n        grid-column: 9 / -1;\n        grid-row: 1 / 3;\n      }\n\n      &:nth-child(3),\n      &:nth-child(4) {\n        grid-row: 2 / 3;\n\n        ', ' {\n          max-height: ', ';\n        }\n      }\n\n      &:nth-child(3) {\n        grid-column: 1 / 5;\n      }\n\n      &:nth-child(4) {\n        grid-column: 5 / 9;\n      }\n    }\n  }\n'], ['\n  ', ';\n  background-color: ', ';\n  padding: 1rem ', ';\n\n  ', ' {\n    background-color: ', ';\n    color: #fff;\n    padding: 1rem;\n    @media (min-width: ', ') {\n      grid-column: 1 / 9;\n      grid-row: 1 / 2;\n    }\n  }\n\n  ', ' {\n    height: 100%;\n  }\n\n  ', ' {\n    ul {\n      display: flex;\n      flex-wrap: wrap;\n    }\n\n    li {\n      &:not(:last-child)::after {\n        content: \'\xB7\';\n        font-weight: bold;\n        margin-left: 0.5rem;\n        margin-right: 0.5rem;\n      }\n    }\n  }\n\n  @media (min-width: ', ') {\n    .gatsby-image-outer-wrapper {\n      &:nth-child(2) {\n        grid-column: 9 / -1;\n        grid-row: 1 / 3;\n      }\n\n      &:nth-child(3),\n      &:nth-child(4) {\n        grid-row: 2 / 3;\n\n        ', ' {\n          max-height: ', ';\n        }\n      }\n\n      &:nth-child(3) {\n        grid-column: 1 / 5;\n      }\n\n      &:nth-child(4) {\n        grid-column: 5 / 9;\n      }\n    }\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  ', ';\n  background-color: ', ';\n  padding: 1rem ', ';\n  grid-auto-flow: dense;\n  min-height: ', ';\n\n  ', ' {\n    background-color: ', ';\n    color: #fff;\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n\n    @media (min-width: ', ') {\n      grid-column: 7 / -1;\n    }\n  }\n\n  ', ' {\n    height: 100%;\n  }\n\n  @media (min-width: ', ') {\n    .gatsby-image-outer-wrapper {\n      &:nth-child(2) {\n        grid-column: 1 / 7;\n      }\n    }\n  }\n'], ['\n  ', ';\n  background-color: ', ';\n  padding: 1rem ', ';\n  grid-auto-flow: dense;\n  min-height: ', ';\n\n  ', ' {\n    background-color: ', ';\n    color: #fff;\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n\n    @media (min-width: ', ') {\n      grid-column: 7 / -1;\n    }\n  }\n\n  ', ' {\n    height: 100%;\n  }\n\n  @media (min-width: ', ') {\n    .gatsby-image-outer-wrapper {\n      &:nth-child(2) {\n        grid-column: 1 / 7;\n      }\n    }\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  ', ';\n  background-color: ', ';\n  padding: 1rem ', ';\n\n  ', ' {\n    background-color: ', ';\n    color: #fff;\n    padding: 1rem;\n\n    @media (min-width: ', ') {\n      grid-column: 1 / 10;\n      grid-row: 1 / 2;\n    }\n  }\n\n  ', ' {\n    height: 100%;\n  }\n\n  ', ' {\n    ul {\n      display: flex;\n      flex-wrap: wrap;\n    }\n\n    li {\n      &:not(:last-child)::after {\n        content: \'\xB7\';\n        font-weight: bold;\n        margin-left: 0.5rem;\n        margin-right: 0.5rem;\n      }\n    }\n  }\n\n  @media (min-width: ', ') {\n    .gatsby-image-outer-wrapper {\n      &:nth-child(2) {\n        grid-column: 6 / 10;\n        grid-row: 2 / 3;\n\n        ', ' {\n          max-height: ', ';\n        }\n      }\n\n      &:nth-child(3) {\n        grid-column: 10 / -1;\n        grid-row: 1 / 3;\n      }\n\n      &:nth-child(4) {\n        grid-column: 1 / 6;\n        grid-row: 2 / 3;\n\n        ', ' {\n          max-height: ', ';\n        }\n      }\n    }\n  }\n'], ['\n  ', ';\n  background-color: ', ';\n  padding: 1rem ', ';\n\n  ', ' {\n    background-color: ', ';\n    color: #fff;\n    padding: 1rem;\n\n    @media (min-width: ', ') {\n      grid-column: 1 / 10;\n      grid-row: 1 / 2;\n    }\n  }\n\n  ', ' {\n    height: 100%;\n  }\n\n  ', ' {\n    ul {\n      display: flex;\n      flex-wrap: wrap;\n    }\n\n    li {\n      &:not(:last-child)::after {\n        content: \'\xB7\';\n        font-weight: bold;\n        margin-left: 0.5rem;\n        margin-right: 0.5rem;\n      }\n    }\n  }\n\n  @media (min-width: ', ') {\n    .gatsby-image-outer-wrapper {\n      &:nth-child(2) {\n        grid-column: 6 / 10;\n        grid-row: 2 / 3;\n\n        ', ' {\n          max-height: ', ';\n        }\n      }\n\n      &:nth-child(3) {\n        grid-column: 10 / -1;\n        grid-row: 1 / 3;\n      }\n\n      &:nth-child(4) {\n        grid-column: 1 / 6;\n        grid-row: 2 / 3;\n\n        ', ' {\n          max-height: ', ';\n        }\n      }\n    }\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  padding-top: 2rem;\n  padding-bottom: 3rem;\n'], ['\n  padding-top: 2rem;\n  padding-bottom: 3rem;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GatsbyImage = __webpack_require__(64);
	
	var _GatsbyImage2 = _interopRequireDefault(_GatsbyImage);
	
	var _PageContainer = __webpack_require__(116);
	
	var _PageContainer2 = _interopRequireDefault(_PageContainer);
	
	var _Container = __webpack_require__(119);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _MarkdownBlock = __webpack_require__(115);
	
	var _MarkdownBlock2 = _interopRequireDefault(_MarkdownBlock);
	
	var _propTypes3 = __webpack_require__(7);
	
	var CustomPropTypes = _interopRequireWildcard(_propTypes3);
	
	var _Type = __webpack_require__(137);
	
	var _Type2 = _interopRequireDefault(_Type);
	
	var _services = __webpack_require__(418);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _vars = __webpack_require__(5);
	
	var _utils = __webpack_require__(6);
	
	var _mixins = __webpack_require__(123);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var BREAK_POINT = 900;
	
	var blockStyles = '\n  display: grid;\n  grid-gap: 1rem;\n\n  &:not(:last-of-type) {\n    margin-bottom: 4rem;\n  }\n\n  @media (min-width: ' + (0, _utils.pxToRem)(BREAK_POINT) + ') {\n    grid-template-columns: repeat(12, 1fr);\n  }\n';
	
	var Content = _styledComponents2.default.div(_templateObject, (0, _mixins.type)(_vars.TYPE_SIZE.t5));
	
	var Intro = (0, _styledComponents2.default)(_Container2.default)(_templateObject2, blockStyles, Content, (0, _utils.pxToRem)(BREAK_POINT), (0, _utils.pxToRem)(BREAK_POINT));
	
	var ConcreteFlatwork = (0, _styledComponents2.default)(_Container2.default)(_templateObject3, blockStyles, _vars.COLORS.gray[1], (0, _utils.pxToRem)((_vars.MAX_CONTENT_WIDTH_PLUS - _vars.MAX_CONTENT_WIDTH) / 2), Content, _vars.COLORS.brand[4], (0, _utils.pxToRem)(BREAK_POINT), _GatsbyImage2.default, _MarkdownBlock2.default, (0, _utils.pxToRem)(BREAK_POINT), _GatsbyImage2.default, (0, _utils.pxToRem)(300));
	
	var StructuralConcrete = (0, _styledComponents2.default)(_Container2.default)(_templateObject4, blockStyles, _vars.COLORS.gray[1], (0, _utils.pxToRem)((_vars.MAX_CONTENT_WIDTH_PLUS - _vars.MAX_CONTENT_WIDTH) / 2), (0, _utils.pxToRem)(400), Content, _vars.COLORS.brand[4], (0, _utils.pxToRem)(BREAK_POINT), _GatsbyImage2.default, (0, _utils.pxToRem)(BREAK_POINT));
	
	var Hardscapes = (0, _styledComponents2.default)(_Container2.default)(_templateObject5, blockStyles, _vars.COLORS.gray[1], (0, _utils.pxToRem)((_vars.MAX_CONTENT_WIDTH_PLUS - _vars.MAX_CONTENT_WIDTH) / 2), Content, _vars.COLORS.brand[4], (0, _utils.pxToRem)(BREAK_POINT), _GatsbyImage2.default, _MarkdownBlock2.default, (0, _utils.pxToRem)(BREAK_POINT), _GatsbyImage2.default, (0, _utils.pxToRem)(300), _GatsbyImage2.default, (0, _utils.pxToRem)(300));
	
	var Services = function (_React$PureComponent) {
	  _inherits(Services, _React$PureComponent);
	
	  function Services() {
	    _classCallCheck(this, Services);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Services.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        data = _props.data;
	
	    var intro = (0, _services2.default)(data.intro, data.images.edges);
	    var concreteFlatwork = (0, _services2.default)(data.concreteFlatwork, data.images.edges);
	    var hardscapes = (0, _services2.default)(data.hardscapes, data.images.edges);
	    var structuralConcrete = (0, _services2.default)(data.structuralConcrete, data.images.edges);
	
	    return _react2.default.createElement(
	      _PageContainer2.default,
	      { plus: true, className: className },
	      _react2.default.createElement(
	        Intro,
	        { tag: 'section' },
	        _react2.default.createElement(
	          Content,
	          null,
	          _react2.default.createElement(_MarkdownBlock2.default, { dangerouslySetInnerHTML: { __html: intro.content } })
	        ),
	        _react2.default.createElement(_GatsbyImage2.default, intro.images[0])
	      ),
	      _react2.default.createElement(
	        ConcreteFlatwork,
	        { plus: true, tag: 'section' },
	        _react2.default.createElement(
	          Content,
	          null,
	          _react2.default.createElement(
	            _Type2.default,
	            { tag: 'h1', uppercase: true, weight: 'medium' },
	            concreteFlatwork.title
	          ),
	          _react2.default.createElement(_MarkdownBlock2.default, { dangerouslySetInnerHTML: { __html: concreteFlatwork.content } })
	        ),
	        concreteFlatwork.images.map(function (image) {
	          return _react2.default.createElement(_GatsbyImage2.default, _extends({}, image, { key: image.id }));
	        })
	      ),
	      _react2.default.createElement(
	        StructuralConcrete,
	        { plus: true, tag: 'section' },
	        _react2.default.createElement(
	          Content,
	          null,
	          _react2.default.createElement(
	            _Type2.default,
	            { tag: 'h1', uppercase: true, weight: 'medium' },
	            structuralConcrete.title
	          ),
	          _react2.default.createElement(_MarkdownBlock2.default, { dangerouslySetInnerHTML: { __html: structuralConcrete.content } })
	        ),
	        structuralConcrete.images.map(function (image) {
	          return _react2.default.createElement(_GatsbyImage2.default, _extends({}, image, { key: image.id }));
	        })
	      ),
	      _react2.default.createElement(
	        Hardscapes,
	        { plus: true, tag: 'section' },
	        _react2.default.createElement(
	          Content,
	          null,
	          _react2.default.createElement(
	            _Type2.default,
	            { tag: 'h1', uppercase: true, weight: 'medium' },
	            hardscapes.title
	          ),
	          _react2.default.createElement(_MarkdownBlock2.default, { dangerouslySetInnerHTML: { __html: hardscapes.content } })
	        ),
	        hardscapes.images.map(function (image) {
	          return _react2.default.createElement(_GatsbyImage2.default, _extends({}, image, { key: image.id }));
	        })
	      )
	    );
	  };
	
	  return Services;
	}(_react2.default.PureComponent);
	
	Services.displayName = 'Services';
	Services.propTypes = {
	  className: _propTypes2.default.string,
	  data: _propTypes2.default.shape({
	    intro: CustomPropTypes.Service,
	    concreteFlatwork: CustomPropTypes.Service,
	    hardscapes: CustomPropTypes.Service,
	    structuralConcrete: CustomPropTypes.Service,
	    images: CustomPropTypes.AllImageSharp
	  }).isRequired
	};
	exports.default = (0, _styledComponents2.default)(Services)(_templateObject6);
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var composeImagesWithMetaData = function composeImagesWithMetaData(imageNodes, imageMeta) {
	  return imageMeta.reduce(function (acc, _ref) {
	    var imagePath = _ref.image,
	        alt = _ref.alt;
	
	    var matchImageNode = imageNodes.find(function (_ref2) {
	      var node = _ref2.node;
	      return node.id.match(imagePath);
	    });
	    if (!matchImageNode) {
	      return acc;
	    }
	    acc.push(_extends({}, matchImageNode.node, {
	      alt: alt
	    }));
	    return acc;
	  }, []);
	};
	
	exports.default = composeImagesWithMetaData;
	module.exports = exports["default"];

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _images = __webpack_require__(140);
	
	var _images2 = _interopRequireDefault(_images);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mergeServiceWithImages = function mergeServiceWithImages() {
	  var service = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var imageEdges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var _service$frontmatter = service.frontmatter;
	  _service$frontmatter = _service$frontmatter === undefined ? {} : _service$frontmatter;
	  var title = _service$frontmatter.title,
	      imageMeta = _service$frontmatter.images,
	      _service$html = service.html,
	      content = _service$html === undefined ? '' : _service$html;
	
	
	  return {
	    title: title,
	    content: content,
	    images: (0, _images2.default)(imageEdges, imageMeta)
	  };
	};
	
	exports.default = mergeServiceWithImages;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-js-a9efdb0b1c01e3b54f70.js